/**
 * 服务器错误
 */
export class HttpServerError extends Error {
  public isServerError = true

  constructor(message: string, public code: number) {
    super(message)
  }

  toJson() {
    return {
      err: true,
      message: this.message,
      code: this.code,
    }
  }
}
